function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMarkets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "markets",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "chart",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 7.390625,-44.685547 a 1,1 0 0 0 -1,1 v 35.982422 a 1.0001,1.0001 0 0 0 1,1 h 35.912109 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 H 8.390625 v -34.982422 a 1,1 0 0 0 -1,-1 z",
    transform: "translate(-0.34698145,50.693962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M 35.807919 -32.193962 A 1 1 0 0 0 34.807919 -31.193962 A 1 1 0 0 0 35.807919 -30.193962 L 38.915341 -30.193962 L 29.7337 -20.984978 L 25.063778 -25.654899 A 1.0001 1.0001 0 0 0 23.655575 -25.660759 L 12.516903 -14.695915 A 1 1 0 0 0 12.507138 -13.281853 A 1 1 0 0 0 13.9212 -13.272087 L 24.352841 -23.539665 L 29.028622 -18.863884 A 1.0001 1.0001 0 0 0 30.444638 -18.863884 L 40.325497 -28.775993 L 40.325497 -25.504509 A 1 1 0 0 0 41.325497 -24.504509 A 1 1 0 0 0 42.325497 -25.504509 L 42.325497 -31.193962 A 1.0001 1.0001 0 0 0 42.321591 -31.225212 A 1 1 0 0 0 42.2962 -31.422478 A 1.0001 1.0001 0 0 0 42.290341 -31.453728 A 1 1 0 0 0 42.280575 -31.481071 A 1 1 0 0 0 42.20831 -31.652946 A 1.0001 1.0001 0 0 0 42.167294 -31.725212 A 1 1 0 0 0 42.036435 -31.897087 A 1 1 0 0 0 42.032528 -31.900993 A 1.0001 1.0001 0 0 0 42.030575 -31.902946 A 1 1 0 0 0 42.026669 -31.906853 A 1.0001 1.0001 0 0 0 41.743466 -32.092399 A 1 1 0 0 0 41.663388 -32.125603 A 1.0001 1.0001 0 0 0 41.325497 -32.193962 L 41.323544 -32.193962 L 35.807919 -32.193962 z ",
    transform: "translate(-0.34698145,50.693962)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarkets);
export default __webpack_public_path__ + "static/media/icon_markets.4ea23ecd1b5acac1977c9a81812f63e6.svg";
export { ForwardRef as ReactComponent };